module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-dropdown-reject-56974cab42feb1e3702184687f8cfc6f.svg";